function createWaitForValidation(getLogger) {
  let validationPending;
  let resolvePendingValidation = () => void 0;
  function waitForValidation(meta) {
    const log = getLogger();
    if (!meta.validating) {
      const isValid = meta.status === "valid";
      log("resolvePendingValidation SYNC", isValid);
      if (validationPending) {
        resolvePendingValidation(isValid);
      }
      return Promise.resolve(isValid);
    }
    if (!validationPending) {
      validationPending = new Promise((resolve) => {
        resolvePendingValidation = (value) => {
          log("resolvePendingValidation ASYNC", value);
          resolve(value);
          resolvePendingValidation = () => void 0;
          validationPending = void 0;
        };
      });
    }
    return validationPending;
  }
  return {
    waitForValidation,
    getResolvePendingValidation: () => resolvePendingValidation,
    getValidationPending: () => validationPending
  };
}
export {
  createWaitForValidation
};
//# sourceMappingURL=createWaitForValidation.js.map
